import React from 'react';
import { Form, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification } from 'antd';
import { getPermissions } from '../../modules/Api';

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class RoleForm extends React.Component{
    constructor() {
        super();
        this.state = {
            allPermissions: [],
            permissions: [],
            selectedPermissions: []
        }
    }

    componentDidMount() {
        getPermissions('', (res)=>{
            this.setState({
                allPermissions: res,
                permissions: res,
                selectedPermissions: this.defaultPermissions(res)
            });
        });
    }

    handleSubmit = e => {
        e.preventDefault();

        if (this.submittedAt > Date.now() - 500) {
            return;
        }

        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({},
                fieldsValue, {
                    permissions: this.state.selectedPermissions.map(t => t.key)
                }
            ));
        })
    }

    fetchPermission(keyword) {
    }

    commitPermissions(items) {
        this.setState({selectedPermissions: items});
    }
    render(){
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        if(this.state.allPermissions.length < 1){
            return 'لطفا منتظر بمانید';
        }
        var permissions = this.getOptions();
        const { getFieldDecorator, getFieldsError } = this.props.form;

        return (
            <div style={{direction: 'rtl'}}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={20} offset={1}>
                            <Form.Item
                                {...formItemLayout}
                                label="نام نقش"
                                style={{direction: "ltr"}}
                                colon={false}>
                                {getFieldDecorator("name", {
                                    initialValue: this.props.initialData.name ? this.props.initialData.name : '',
                                    rules: [{
                                        required: true, message: 'فیلد را با کلمات انگلیسی پرکنید',
                                        pattern: new RegExp(
                                            /^[a-z]+$/i
                                        ),
                                    }],
                                })(
                                    <Input/>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20} offset={1}>
                            <Form.Item
                                {...formItemLayout}
                                label="عنوان نقش"
                                style={{direction: "rtl"}}
                                colon={false}>
                                {getFieldDecorator("title", {
                                    initialValue: this.props.initialData.title ? this.props.initialData.title : '',
                                    rules: [{
                                        required: true, message: 'فیلد را پر کنید',
                                    }],
                                })(
                                    <Input/>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20} offset={1}>
                            <Form.Item
                                {...formItemLayout}
                                label="دسترسی"
                                colon={false}>
                                {getFieldDecorator('permissions', {
                                    initialValue: this.state.selectedPermissions,
                                    rules: [{
                                        required: true
                                    }]
                                })(
                                    <Select
                                        mode="multiple"
                                        labelInValue
                                        placeholder="انتخاب دسترسی"
                                        notFoundContent={this.state.loading ? <Spin size="small" /> : null}
                                        onSearch={this.fetchPermission.bind(this)}
                                        onChange={this.commitPermissions.bind(this)}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        >
                                        {permissions}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item>
                        <div className="btn-container">
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={hasErrors(getFieldsError()) || this.props.submitted}
                                >
                                {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        );
    }

    getOptions() {
        let permissions = [];
        this.state.permissions.map((d)=> {
            let duplicate = false;
            for (let i in this.state.selectedPermissions) {
                if (this.state.selectedPermissions[i].key == d.id) {
                    duplicate = true;
                    break;
                }
            }
            if (!duplicate) {
                permissions[permissions.length] = <Select.Option key={d.id}>{d.label}</Select.Option>;
            }
        });
        return permissions;
    }

    defaultPermissions(allPermissions) {
        if(!this.props.initialData.permissions){
            return [];
        }
        let permissions = [];
        for(let i in allPermissions){
            for(let j in this.props.initialData.permissions){
                if(allPermissions[i].id == this.props.initialData.permissions[j]){
                    permissions[permissions.length] = {key: allPermissions[i].id, label: allPermissions[i].label};
                }
            }
        }
        return permissions;
    }
}
export default Form.create({ name: 'horizontal_login' })(RoleForm);



// WEBPACK FOOTER //
// ./src/containers/ACL/role_form.js